<template>
    <svg :class="className" width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.07115 1.14872C3.80878 1.14872 2.78544 2.17207 2.78544 3.43443V4.00586H7.35686V3.43443C7.35686 2.17207 6.33352 1.14872 5.07115 1.14872ZM1.64258 3.43443V4.19846C0.967029 4.51951 0.5 5.20814 0.5 6.00586V10.0059C0.5 11.1104 1.39543 12.0059 2.5 12.0059H7.64286C8.74743 12.0059 9.64286 11.1104 9.64286 10.0059V6.00586C9.64286 5.20792 9.17557 4.51913 8.49972 4.19819V3.43443C8.49972 1.54088 6.9647 0.00585938 5.07115 0.00585938C3.1776 0.00585938 1.64258 1.54088 1.64258 3.43443ZM4.38672 6.52051V9.72051H5.75815V6.52051H4.38672Z"/>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
